(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || drawer.dataset.ready === 'true') return;
    drawer.dataset.ready = 'true';

    const panel = drawer.querySelector('[data-cart-drawer-panel]');
    const itemContainer = drawer.querySelector('[data-cart-drawer-items]');
    const emptyElement = drawer.querySelector('[data-cart-drawer-empty]');
    const footerElement = drawer.querySelector('[data-cart-drawer-footer]');
    const eyebrowElement = drawer.querySelector('[data-cart-drawer-eyebrow]');
    const progressElement = drawer.querySelector('[data-cart-drawer-progress]');
    const totalElement = drawer.querySelector('[data-cart-drawer-total]');
    const progressMessage = drawer.querySelector('[data-cart-drawer-progress-message]');
    const progressTrack = drawer.querySelector('[data-cart-drawer-progress-track]');
    const progressBar = drawer.querySelector('[data-cart-drawer-progress-bar]');
    const recommendations = drawer.querySelector('[data-cart-drawer-recommendations]');
    const errorElement = drawer.querySelector('[data-cart-drawer-error]');
    const statusElement = drawer.querySelector('[data-cart-drawer-status]');
    const threshold = Number(drawer.dataset.deliveryThreshold) || 2500;
    const rootUrl = drawer.dataset.rootUrl.endsWith('/') ? drawer.dataset.rootUrl : `${drawer.dataset.rootUrl}/`;
    let previousActiveElement;
    let closeTimer;
    let cartIsUpdating = false;

    const formatMoney = (amount, currency) => {
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount / 100);
      } catch (error) {
        return `${(amount / 100).toFixed(2)} ${currency}`;
      }
    };

    const fillTemplate = (template, values) => {
      return Object.entries(values).reduce((copy, [key, value]) => copy.replace(`[${key}]`, value), template);
    };

    const updateHeaderCount = (count) => {
      document.querySelectorAll('[data-cart-link]').forEach((link) => {
        link.setAttribute('aria-label', fillTemplate(drawer.dataset.cartLabelTemplate, { count }));
        const badge = link.querySelector('[data-cart-count]');
        if (!badge) return;
        badge.textContent = count;
        badge.hidden = count === 0;
      });
    };

    const makeItem = (item, currency) => {
      const article = document.createElement('article');
      article.className = 'cart-drawer__item';
      article.dataset.cartItemKey = item.key;

      const media = document.createElement('a');
      media.className = 'cart-drawer__item-media';
      media.href = item.url;
      if (item.featured_image?.url) {
        const image = document.createElement('img');
        image.src = item.featured_image.url;
        image.alt = item.featured_image.alt || item.product_title;
        image.width = 176;
        image.height = 176;
        media.appendChild(image);
      }

      const copy = document.createElement('div');
      copy.className = 'cart-drawer__item-copy';
      const title = document.createElement('a');
      title.className = 'cart-drawer__item-title';
      title.href = item.url;
      title.textContent = item.product_title;
      copy.appendChild(title);

      const meta = document.createElement('div');
      meta.className = 'cart-drawer__item-meta';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        const variant = document.createElement('span');
        variant.textContent = item.variant_title;
        meta.appendChild(variant);
      }
      copy.appendChild(meta);

      const actions = document.createElement('div');
      actions.className = 'cart-drawer__item-actions';
      const quantityControl = document.createElement('div');
      quantityControl.className = 'cart-drawer__quantity-control';

      const decrease = document.createElement('button');
      decrease.type = 'button';
      decrease.textContent = '−';
      decrease.disabled = item.quantity <= 1;
      decrease.dataset.cartItemAction = 'decrease';
      decrease.setAttribute('aria-label', fillTemplate(drawer.dataset.decreaseTemplate, { product: item.product_title }));
      decrease.addEventListener('click', () => changeLine(item, item.quantity - 1, decrease));

      const quantityValue = document.createElement('span');
      quantityValue.className = 'cart-drawer__quantity-value';
      quantityValue.textContent = item.quantity;
      quantityValue.setAttribute('aria-live', 'polite');

      const increase = document.createElement('button');
      increase.type = 'button';
      increase.textContent = '+';
      increase.dataset.cartItemAction = 'increase';
      increase.setAttribute('aria-label', fillTemplate(drawer.dataset.increaseTemplate, { product: item.product_title }));
      increase.addEventListener('click', () => changeLine(item, item.quantity + 1, increase));

      quantityControl.append(decrease, quantityValue, increase);

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'cart-drawer__remove';
      remove.textContent = drawer.dataset.removeLabel;
      remove.dataset.cartItemAction = 'remove';
      remove.setAttribute('aria-label', fillTemplate(drawer.dataset.removeTemplate, { product: item.product_title }));
      remove.addEventListener('click', () => changeLine(item, 0, remove));

      actions.append(quantityControl, remove);
      copy.appendChild(actions);

      const price = document.createElement('strong');
      price.className = 'cart-drawer__item-price';
      price.textContent = formatMoney(item.final_line_price, currency);

      article.append(media, copy, price);
      return article;
    };

    const updateRecommendations = (cart) => {
      if (!recommendations) return;
      if (cart.total_price >= threshold) {
        recommendations.hidden = true;
        return;
      }
      const cartHandles = new Set(cart.items.map((item) => item.handle));
      let visibleCount = 0;
      recommendations.querySelectorAll('[data-cart-recommendation]').forEach((recommendation) => {
        const shouldShow = visibleCount < 2 && !cartHandles.has(recommendation.dataset.productHandle);
        recommendation.hidden = !shouldShow;
        if (shouldShow) visibleCount += 1;
      });
      recommendations.hidden = visibleCount === 0;
    };

    const renderCart = (cart) => {
      const currency = cart.currency || 'EUR';
      const isEmpty = cart.item_count === 0;
      itemContainer.textContent = '';
      updateHeaderCount(cart.item_count);
      itemContainer.hidden = isEmpty;
      emptyElement.hidden = !isEmpty;
      progressElement.hidden = isEmpty;
      footerElement.hidden = isEmpty;
      eyebrowElement.textContent = isEmpty ? drawer.dataset.emptyLabel : drawer.dataset.addedLabel;

      if (isEmpty) {
        if (recommendations) recommendations.hidden = true;
        totalElement.textContent = '';
        return;
      }

      cart.items.forEach((item) => itemContainer.appendChild(makeItem(item, currency)));
      totalElement.textContent = formatMoney(cart.total_price, currency);

      const remaining = Math.max(0, threshold - cart.total_price);
      const progress = Math.min(100, Math.round((cart.total_price / threshold) * 100));
      const unlocked = remaining === 0;
      progressMessage.textContent = unlocked
        ? drawer.dataset.unlockedTemplate
        : fillTemplate(drawer.dataset.remainingTemplate, { amount: formatMoney(remaining, currency) });
      progressTrack.setAttribute('aria-valuenow', progress);
      progressBar.style.width = `${progress}%`;
      updateRecommendations(cart);
    };

    const changeLine = async (item, quantity, trigger) => {
      if (cartIsUpdating) return;
      const action = quantity === 0 ? 'remove' : quantity > item.quantity ? 'increase' : 'decrease';
      cartIsUpdating = true;
      trigger.setAttribute('aria-busy', 'true');
      panel.setAttribute('aria-busy', 'true');
      const actionButtons = Array.from(panel.querySelectorAll('[data-cart-item-action]'));
      const disabledStates = new Map(actionButtons.map((button) => [button, button.disabled]));
      actionButtons.forEach((button) => { button.disabled = true; });
      errorElement.hidden = true;

      try {
        const response = await fetch(`${rootUrl}cart/change.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ id: item.key, quantity }),
          credentials: 'same-origin'
        });
        const result = await response.json();
        if (!response.ok) {
          const cartError = new Error(result.description || drawer.dataset.updateError);
          cartError.isCartError = true;
          throw cartError;
        }
        renderCart(result);
        statusElement.textContent = quantity === 0
          ? fillTemplate(drawer.dataset.removedTemplate, { product: item.product_title })
          : drawer.dataset.updatedLabel;
        if (quantity === 0) {
          const focusTarget = result.item_count === 0 ? emptyElement.querySelector('a') : panel;
          focusTarget?.focus({ preventScroll: true });
        } else {
          const updatedRow = Array.from(panel.querySelectorAll('[data-cart-item-key]')).find((row) => row.dataset.cartItemKey === item.key);
          updatedRow?.querySelector(`[data-cart-item-action="${action}"]`)?.focus({ preventScroll: true });
        }
      } catch (error) {
        errorElement.textContent = error.isCartError ? error.message : drawer.dataset.updateError;
        errorElement.hidden = false;
        try {
          renderCart(await fetchCart());
        } catch (fetchError) {
          statusElement.textContent = drawer.dataset.updateError;
        }
      } finally {
        cartIsUpdating = false;
        panel.removeAttribute('aria-busy');
        actionButtons.forEach((button) => {
          if (!button.isConnected) return;
          button.disabled = disabledStates.get(button);
          button.removeAttribute('aria-busy');
        });
      }
    };

    const openDrawer = () => {
      window.clearTimeout(closeTimer);
      previousActiveElement = document.activeElement;
      drawer.hidden = false;
      document.body.classList.add('cart-drawer-open');
      window.requestAnimationFrame(() => {
        drawer.classList.add('is-open');
        panel.focus({ preventScroll: true });
      });
    };

    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      document.body.classList.remove('cart-drawer-open');
      closeTimer = window.setTimeout(() => {
        drawer.hidden = true;
        previousActiveElement?.focus({ preventScroll: true });
      }, 290);
    };

    const fetchCart = async () => {
      const response = await fetch(`${rootUrl}cart.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error('cart-fetch-failed');
      return response.json();
    };

    drawer.querySelectorAll('[data-cart-drawer-close]').forEach((button) => button.addEventListener('click', closeDrawer));

    document.addEventListener('keydown', (event) => {
      if (drawer.hidden) return;
      if (event.key === 'Escape') closeDrawer();
      if (event.key !== 'Tab') return;
      const focusable = Array.from(panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'));
      if (focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('form.product-main__form, form.product-card__form');
      if (!form || !window.fetch || !window.FormData) return;
      const submitter = event.submitter;
      if (!submitter?.matches('[data-add-to-cart], .product-card__quick-add')) return;

      event.preventDefault();
      submitter.disabled = true;
      submitter.setAttribute('aria-busy', 'true');
      errorElement.hidden = true;

      try {
        const response = await fetch(`${rootUrl}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
          credentials: 'same-origin'
        });
        const result = await response.json();
        if (!response.ok) {
          const cartError = new Error(result.description || drawer.dataset.addError);
          cartError.isCartError = true;
          throw cartError;
        }
        const cart = await fetchCart();
        renderCart(cart);
        statusElement.textContent = drawer.dataset.addedLabel;
        openDrawer();
      } catch (error) {
        if (!error.isCartError) {
          HTMLFormElement.prototype.submit.call(form);
          return;
        }
        errorElement.textContent = error.message || drawer.dataset.addError;
        errorElement.hidden = false;
        try {
          renderCart(await fetchCart());
        } catch (fetchError) {
          itemContainer.textContent = '';
        }
        openDrawer();
      } finally {
        submitter.disabled = false;
        submitter.removeAttribute('aria-busy');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
